export default __webpack_public_path__ + "static/media/layout-type-horizontal.6ac612b8.svg";